import React, { useEffect, useState } from "react";
import image1 from "../../assets/1e8674ca-9bad-49b2-9c92-9618d9d73bff.webp";
import image2 from "../../assets/fullscreen/branding.jpg";
import shoe1 from "../../assets/shoe1.jpg";
import shoe2 from "../../assets/shoe2.jpg";
import shoe3 from "../../assets/shoe3.jpg";
import shoe4 from "../../assets/shoe4.jpg";
import shoe5 from "../../assets/shoe5.jpg";
import teamCollection from "../../assets/TeamCollection.jpg";
import dressToImpress from "../../assets/dressToImpress.jpg";
import mens from "../../assets/mens.jpg";
import womens from "../../assets/womens.jpg";
import kids from "../../assets/kids.jpg";
import ReactPlayer from "react-player";
import { Link, useNavigate } from "react-router-dom";
import { HiArrowNarrowRight, HiArrowNarrowLeft } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { setFilterSync } from "../../features/common/commonSlice";
const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const shoeOptions = [
    {
      image: shoe5,
      name: "Air Max 270",
      link: "/productOverview/65016bf8c5b96a37a9c854f0",
    },
    {
      image: shoe3,
      name: "Air Max 95",
      link: "/productOverview/65016ccac5b96a37a9c854f2",
    },
    {
      image: shoe1,
      name: "Air Max 97",
      link: "/productOverview/65016de7c5b96a37a9c8553d",
    },
    {
      image: shoe4,
      name: "Air Max Plus",
      link: "/productOverview/65016eacc5b96a37a9c8553f",
    },
    {
      image: shoe2,
      name: "Air Max 90",
      link: "/productOverview/65016fbac5b96a37a9c8557d",
    },
  ];
  const [showIcons, setShowIcons] = useState(false);
  const [showShoes, setShowShoes] = useState(false);
  const [showClothing, setShowClothing] = useState(false);
  const [showKids, setShowKids] = useState(false);
  const [windowDimention, setWindowDimention] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const detectSize = () => {
    setWindowDimention({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  const handleScroll = (direction) => {
    const container = document.querySelector(".scroll-container");
    const scrollAmount = 300; // Adjust this value as needed
    if (direction === "left") {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }
  };
  const handleJordanShop = () => {
    dispatch(setFilterSync({ category: ["Jordan Brand"] }));
    navigate("/home");
  };
  const handleMens = () => {
    dispatch(setFilterSync({ gender: ["Men"] }));
    navigate("/home");
  };
  const handleWomens = () => {
    dispatch(setFilterSync({ gender: ["Women"] }));
    navigate("/home");
  };
  const handleKids = () => {
    dispatch(setFilterSync({ kids: ["Girls", "Boys"] }));
    navigate("/home");
  };
  const handleJersey = () => {
    dispatch(setFilterSync({ category: ["Jersey"] }));
    navigate("/home");
  };
  const handleJackets = () => {
    dispatch(setFilterSync({ category: ["Jackets"] }));
    navigate("/home");
  };
  const handleAllShoes = () => {
    dispatch(setFilterSync({ category: ["Footwear"] }));
    navigate("/home");
  };
  const handleKidsShoes = () => {
    dispatch(
      setFilterSync({ category: ["Footwear"], kids: ["Girls", "Boys"] })
    );
    navigate("/home");
  };

  const handleMensShoes = () => {
    dispatch(setFilterSync({ category: ["Footwear"], gender: ["Men"] }));
    navigate("/home");
  };
  const handleWomensShoes = () => {
    dispatch(setFilterSync({ category: ["Footwear"], gender: ["Women"] }));
    navigate("/home");
  };
  const handleUnisexShoes = () => {
    dispatch(setFilterSync({ category: ["Footwear"], gender: ["Unisex"] }));
    navigate("/home");
  };
  const handleBoysShoes = () => {
    dispatch(setFilterSync({ category: ["Footwear"], kids: ["Boys"] }));
    navigate("/home");
  };
  const handleGirlsShoes = () => {
    dispatch(setFilterSync({ category: ["Footwear"], kids: ["Girls"] }));
    navigate("/home");
  };
  const handleKidsHoodies = () => {
    dispatch(setFilterSync({ category: ["Hoodies"], kids: ["Girls", "Boys"] }));
    navigate("/home");
  };
  const handleKidsJersey = () => {
    dispatch(setFilterSync({ category: ["Jersey"], kids: ["Girls", "Boys"] }));
    navigate("/home");
  };
  const handleKidsSportsBra = () => {
    dispatch(
      setFilterSync({ category: ["Sports Bras"], kids: ["Girls", "Boys"] })
    );
    navigate("/home");
  };
  const handleKidsJackets = () => {
    dispatch(setFilterSync({ category: ["Jackets"], kids: ["Girls", "Boys"] }));
    navigate("/home");
  };
  const handleKidsSocks = () => {
    dispatch(setFilterSync({ category: ["Socks"], kids: ["Girls", "Boys"] }));
    navigate("/home");
  };

  const handleTSirts = () => {
    dispatch(setFilterSync({ category: ["T-Shirts"] }));
    navigate("/home");
  };

  const handlePants = () => {
    dispatch(setFilterSync({ category: ["Pants"] }));
    navigate("/home");
  };

  const handleHoodies = () => {
    dispatch(setFilterSync({ category: ["Hoodies"] }));
    navigate("/home");
  };

  const handleDress = () => {
    dispatch(setFilterSync({ category: ["Dresses"] }));
    navigate("/home");
  };

  const handleSportsBras = () => {
    dispatch(setFilterSync({ category: ["Sports Bras"] }));
    navigate("/home");
  };

  const HandleAllClothing = () => {
    dispatch(
      setFilterSync({
        category: [
          "Socks",
          "Sports Bras",
          "Dresses",
          "Jackets",
          "Hoodies",
          "Pants",
          "T-Shirts",
        ],
      })
    );
    navigate("/home");
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimention]);
  return (
    <header>
      <div className="px-5 md:px-12 w-full">
        <div className="first mb-32 md:mb-14">
          {windowDimention.winWidth > 768 ? (
            <img src={image2} className="w-full" alt="" />
          ) : (
            <img src={image1} alt="" />
          )}
          <div className="first-text text-left md:text-center ">
            <p className="mt-7">Air Max 1</p>
            <h1 className=" text-bolder md:text-bolder-md">No Genres</h1>
            <h1 className="text-bolder md:text-bolder-md">All Soul</h1>
            <Link to="/home">
              <button className="shop-button mt-12   ">Shop All</button>
            </Link>
          </div>
        </div>
        <div className="second mb-24">
          <div className="text-left flex justify-between items-center">
            <p className="text-lg px-2 py-7">Air Max Collection</p>
            <div className="slide-buttons md:flex hidden">
              <div className="border-2 border-black rounded-full h-5 w-5 m-2">
                <HiArrowNarrowLeft onClick={() => handleScroll("left")} />
              </div>
              <div className="border-2 border-black rounded-full h-5 w-5 m-2 ">
                <HiArrowNarrowRight onClick={() => handleScroll("right")} />
              </div>
            </div>
          </div>
          <div className="scroll-container scroll-smooth flex flex-row overflow-x-auto ">
            {shoeOptions.map((shoe) => (
              <div
                className=" mx-2 text-left"
                onClick={() => navigate(shoe.link)}
              >
                <img
                  src={shoe.image}
                  className="max-w-[70vw] md:max-w-[30vw]"
                  alt=""
                />
                <p className="text-xl px-2 py-5">{shoe.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="third mb-16">
          <div className="text-left">
            <p className="text-lg px-2 py-7 md:text-[2vw]">Just In</p>
            {windowDimention.winWidth > 768 ? (
              // <video
              //   src={nikeVideoFull}
              //   autoPlay
              //   muted
              //   loop
              //   className="mb-12 w-full "
              // ></video>

              <ReactPlayer
                url="https://youtu.be/VnE7m8JI7MY"
                loop
                playing
                muted
                style={{ pointerEvents: "none" }}
                width="100%"
                className="mb-12 "
                height="100vh"
              />
            ) : (
              // <video
              //   src={nikeVideo}
              //   autoPlay
              //   muted
              //   loop
              //   className="mb-12"
              // ></video>
              <ReactPlayer
                url="https://youtube.com/shorts/YD0wQxl48ZI"
                loop
                playing
                muted
                style={{ pointerEvents: "none" }}
                width="100%"
                className="mb-12 "
                height="65vh"
              />
            )}
            <div className="first-text md:text-center">
              <h1 className=" text-bolder mb-5 md:text-bolder-md ">
                Nike Tech
              </h1>
              <p>
                Engineered to the Exact Specification of Championship Athletes
              </p>
              <Link to="/productOverview/64f8308bcc8ab5b2960ccf42">
                <button className="shop-button my-5">
                  Shop Air Jordan 1 Mid
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="md:flex md:justify-center">
          <div className="fourth text-left">
            <h1 className="text-lg mb-4 md:text-[2vw]">Trending</h1>
            <div className="md:relative">
              <img src={teamCollection} alt="" />
              <div className="first-text my-5 mx-4 space-y-5 md:absolute bottom-10 left-10">
                <h1 className="text-lg ">National Team collection</h1>
                <button className="shop-button" onClick={handleJersey}>
                  Shop
                </button>
              </div>
            </div>
          </div>
          <div className="fifth relative ">
            <img src={dressToImpress} className="opacity-90" alt="" />
            <div className="text-first  absolute bottom-5 md:bottom-48 left-5 space-y-5 ">
              <h1 className="text-white">Dress to Impress</h1>
              <button className="shop-button-white" onClick={handleKids}>
                Shop
              </button>
            </div>
          </div>
        </div>
        <div className="sixth text-left md:text-center">
          <h1 className="text-lg mt-10 mb-4 md:text-[2vw] text-left">
            The Latest
          </h1>
          {windowDimention.winWidth > 768 ? (
            <ReactPlayer
              url="https://youtu.be/O-JXUhhIRHU"
              loop
              playing
              muted
              style={{ pointerEvents: "none" }}
              width="100%"
              className="mb-12 "
              height="80vh"
            />
          ) : (
            <ReactPlayer
              url="https://youtube.com/shorts/V5Vfjd1am4E"
              loop
              playing
              muted
              style={{ pointerEvents: "none" }}
              width="100%"
              className="mb-12 "
              height="65vh"
            />
          )}

          <p>Nike App Early Access</p>
          <h1 className="text-bolder md:text-bolder-md">Air Jordan XXXVIII </h1>
          <h1 className="text-bolder md:text-bolder-md">"Fundamental"</h1>
          <div className="text-center flex justify-start md:justify-center w-full">
            <p className="md:max-w-[50%]">
              Enter the next chapter of the Air Jordan Legacy . Build to run
              floor , our "Fundamental" white,black and red colours way keeps
              the newest AJ true to our Jordan Brand DNA
            </p>
          </div>
          {/* search for air jordans */}
          <button className="shop-button my-5" onClick={handleJordanShop}>
            Shop
          </button>
        </div>
        <div className="seventh text-left">
          <h3 className="text-lg my-5 md:text-[2vw]">Don't Miss</h3>
          {windowDimention.winWidth > 768 ? (
            <ReactPlayer
              url="https://youtu.be/E2-efiAcS3w"
              loop
              playing
              muted
              style={{ pointerEvents: "none" }}
              width="100%"
              className="mb-12 "
              height="80vh"
            />
          ) : (
            <ReactPlayer
              url="https://youtube.com/shorts/_Df7NxfmvQA"
              loop
              playing
              muted
              style={{ pointerEvents: "none" }}
              width="100%"
              className="mb-12 "
              height="65vh"
            />
          )}
          <div className="firstText md:text-center">
            <p>Jordan Apparel</p>
            <h1 className="text-bolder md:text-bolder-md">
              Shades of <br className="md:hidden"></br> blue
            </h1>
            <p className="py-8">
              Keep your looks cool in wover pants , warm up jackets and fleece
              pieces
            </p>
            <button className="shop-button" onClick={handleJackets}>
              Shop
            </button>
          </div>
        </div>
        <div className="eight text-left py-12 ">
          <p className="text-lg my-6">The Essentials</p>
          <div className="eight-images sm:flex">
            <div className="first-img relative my-3 sm:mx-2">
              <img src={mens} alt="" />
              <button
                className="shop-button-white absolute bottom-5 left-5"
                onClick={handleMens}
              >
                {" "}
                Men's
              </button>
            </div>
            <div className="first-img relative my-3 sm:mx-2">
              <img src={womens} alt="" />
              <button
                className="shop-button-white absolute bottom-5 left-5"
                onClick={handleWomens}
              >
                {" "}
                Women's
              </button>
            </div>
            <div className="first-img relative my-3 sm:mx-2">
              <img src={kids} alt="" />
              <button
                className="shop-button-white absolute bottom-5 left-5"
                onClick={handleKids}
              >
                {" "}
                Kid's
              </button>
            </div>
          </div>
        </div>
        <div className="nine  text-left py-12 sm:flex sm:justify-around">
          <div className="firstOption my-4 ">
            <h2
              className="text-lg font-Oswald "
              onClick={() => setShowIcons((show) => !show)}
            >
              Icons
            </h2>
            <div
              className={`firstOptions my-3 mx-6 space-y-2 opacity-50  ${
                showIcons ? "block" : "hidden"
              } sm:block sm:text-s sm:mx-0`}
            >
              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/64f82da7cc8ab5b2960ccebe")
                }
              >
                Air Jordan 7 Retro
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/64f8308bcc8ab5b2960ccf42")
                }
              >
                Air Jordan 1 Mid
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/65016fbac5b96a37a9c8557d")
                }
              >
                Air Max 90
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/65016ccac5b96a37a9c854f2")
                }
              >
                Air Max 95
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/65016de7c5b96a37a9c8553d")
                }
              >
                Air Max 97
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/65016bf8c5b96a37a9c854f0")
                }
              >
                Air Max 270
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/6502ef191c82b4329757ca88")
                }
              >
                Air Max 365
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/65016eacc5b96a37a9c8553f")
                }
              >
                Air Max Plus
              </p>

              <p
                className="cursor-pointer"
                onClick={() =>
                  navigate("/productOverview/64eeda3cb53c2a7d1f779749")
                }
              >
                Air Max SC
              </p>
            </div>
          </div>
          <div className="secondOption my-4">
            <h2
              className="text-lg font-Oswald "
              onClick={() => setShowShoes((show) => !show)}
            >
              Shoes
            </h2>
            <div
              className={`secondOptions my-3 mx-6 space-y-2 opacity-50 ${
                showShoes ? "block" : "hidden"
              } sm:block sm:text-s sm:mx-0`}
            >
              <p className="cursor-pointer" onClick={handleAllShoes}>
                All Shoes
              </p>
              <p className="cursor-pointer" onClick={handleJordanShop}>
                Jordan Shoes
              </p>
              <p className="cursor-pointer" onClick={handleMensShoes}>
                Mens Shoes
              </p>
              <p className="cursor-pointer" onClick={handleWomensShoes}>
                Womens Shoes
              </p>
              <p className="cursor-pointer" onClick={handleUnisexShoes}>
                Unisex Shoes
              </p>
              <p className="cursor-pointer" onClick={handleGirlsShoes}>
                Girls Shoes
              </p>
              <p className="cursor-pointer" onClick={handleBoysShoes}>
                Boys Shoes
              </p>
              <p className="cursor-pointer" onClick={handleAllShoes}>
                Lifestyle Shoes
              </p>
            </div>
          </div>
          <div className="thirdOption my-4">
            <h2
              className="text-lg font-Oswald "
              onClick={() => setShowClothing((show) => !show)}
            >
              Clothing
            </h2>
            <div
              className={`thirdOptions my-3 mx-6 space-y-2 opacity-50 ${
                showClothing ? "block" : "hidden"
              } sm:block sm:text-s sm:mx-0`}
            >
              <p className="cursor-pointer" onClick={HandleAllClothing}>
                All Clothing
              </p>
              <p className="cursor-pointer" onClick={handleTSirts}>
                T - Shirt
              </p>
              <p className="cursor-pointer" onClick={handlePants}>
                Pants
              </p>
              <p className="cursor-pointer" onClick={handleHoodies}>
                Hoodies{" "}
              </p>
              <p className="cursor-pointer" onClick={handleJackets}>
                Jackets
              </p>
              <p className="cursor-pointer" onClick={handleDress}>
                Dress
              </p>
              <p className="cursor-pointer" onClick={handleSportsBras}>
                Sports Bras
              </p>
              <p className="cursor-pointer" onClick={handleJersey}>
                Jersey
              </p>
            </div>
          </div>
          <div className="fourthOption my-4">
            <h2
              className="text-lg font-Oswald "
              onClick={() => setShowKids((show) => !show)}
            >
              Kids'
            </h2>
            <div
              className={`fourthOptions my-3 mx-6 space-y-2 opacity-50 ${
                showKids ? "block" : "hidden"
              } sm:block sm:text-s sm:mx-0`}
            >
              <p className="cursor-pointer" onClick={handleKids}>
                Infant & Toddler Shoes
              </p>
              <p className="cursor-pointer" onClick={handleKidsShoes}>
                Kids' Shoes
              </p>
              <p className="cursor-pointer" onClick={handleKidsHoodies}>
                Kids' Hoodies
              </p>
              <p className="cursor-pointer" onClick={handleKidsJersey}>
                Kids' Jersey
              </p>
              <p className="cursor-pointer" onClick={handleKidsSportsBra}>
                Kids' Sports Bra
              </p>
              <p className="cursor-pointer" onClick={handleKidsJackets}>
                Kids' Jackets
              </p>
              <p className="cursor-pointer" onClick={handleKidsSocks}>
                Kids' Socks
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
